













































































































import {API} from '@/services/api/api';
import validator from '@/utils/validator';
import moment from 'moment';
import {Vue, Component, Provide, Emit, Watch, Prop} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  computed: {...mapGetters(['currentTabActionPlan'])},
})
export default class Implementation extends Vue {
  @Prop({default: false}) canFetchDataFromAPI!: boolean;

  isScreenLoading = false;
  loadingBtnStatus = false;
  implementation = '';
  implValidationMsg = '';
  implDate = '';
  implDateValidationMsg = '';
  commonValidationMsg = 'This field is required';
  showSuccessToast: any;
  showErrorToast: any;
  btnLoader = false;
  inspectionId = this.$route.params.id;
  isReadOnly = true;
  currentTabActionPlan: any;

  typeOfIssue = [
    {
      id: 1,
      name: 'Strutural',
    },
    {
      id: 2,
      name: 'Non Structural',
    },
    {
      id: 3,
      name: 'Other  ',
    },
  ];

  mounted() {
    if (this.currentTabActionPlan.child === this.currentTabActionPlan.navigateTo) this.isReadOnly = false;
    else this.isReadOnly = true;
    this.getActionPlanData();
  }

  async getActionPlanData() {
    try {
      this.isScreenLoading = true;
      let response = await API.fetchActionPlanDataByInspectionId(this.inspectionId);

      if (response.data) {
        const data = response.data;
        const implementation = data.implementation;
        this.implementation = implementation.implementation;
        this.implDate = moment(implementation.implementDate).format('YYYY-MM-DD');
      } else {
        this.showErrorToast({msg: response.error});
        this.isReadOnly = true;
      }
    } catch (e) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  validateImplementaion() {
    if (validator.isNullOrEmpty(this.implementation)) {
      this.implValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.implValidationMsg = '';
      return true;
    }
  }

  validateImplDate() {
    if (validator.isNullOrEmpty(this.implDate)) {
      this.implDateValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.implDateValidationMsg = '';
      return true;
    }
  }

  async onSaveClick() {
    if (this.validateImplementaion() && this.validateImplDate()) {
      try {
        this.btnLoader = true;

        const params = {
          inspectionId: this.inspectionId,
          implementation: {
            implementation: this.implementation,
            implementDate: this.implDate,
          },
        };

        const response = await API.saveActionPlanData(params);
        if (response.data) {
          this.$router.push('/inspection-list');
        } else {
          this.showErrorToast({msg: response.error});
        }
      } catch (error) {
        console.error(error);
        this.showErrorToast({msg: error});
      } finally {
        this.btnLoader = false;
      }
    }
  }

  onCancelClick() {
    this.$router.go(-1);
  }
}
